import { useContext } from 'react';
import AuthContext from '@/context/auth-context';

/**
 * Custom hook to use the authentication context
 * Provides access to user info, auth state, and login/logout functions
 */
const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

export default useAuth; 